// extracted by mini-css-extract-plugin
export var box_2 = "blog-posts-module--box_2--sR3en";
export var box_3 = "blog-posts-module--box_3--ncJOK";
export var container = "blog-posts-module--container--waJzh";
export var hero = "blog-posts-module--hero--Bj-nc";
export var img = "blog-posts-module--img--ERYuk";
export var tag_div = "blog-posts-module--tag_div--6Fohx";
export var title = "blog-posts-module--title--7KPLQ";